import * as Types from '../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvokableAISkillsVariables = Types.Exact<{ [key: string]: never }>;

export type InvokableAISkills = {
  invokableAISkills: Array<Pick<Types.AISkillListItem, 'name' | 'displayName' | 'description'>>;
};

export const InvokableAISkillsDocument = gql`
  query InvokableAISkills {
    invokableAISkills {
      name
      displayName
      description
    }
  }
`;

/**
 * __useInvokableAISkills__
 *
 * To run a query within a React component, call `useInvokableAISkills` and pass it any options that fit your needs.
 * When your component renders, `useInvokableAISkills` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvokableAISkills({
 *   variables: {
 *   },
 * });
 */
export function useInvokableAISkills(
  baseOptions?: Apollo.QueryHookOptions<InvokableAISkills, InvokableAISkillsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InvokableAISkills, InvokableAISkillsVariables>(
    InvokableAISkillsDocument,
    options,
  );
}
export function useInvokableAISkillsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InvokableAISkills, InvokableAISkillsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InvokableAISkills, InvokableAISkillsVariables>(
    InvokableAISkillsDocument,
    options,
  );
}
export function useInvokableAISkillsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<InvokableAISkills, InvokableAISkillsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InvokableAISkills, InvokableAISkillsVariables>(
    InvokableAISkillsDocument,
    options,
  );
}
export type InvokableAISkillsHookResult = ReturnType<typeof useInvokableAISkills>;
export type InvokableAISkillsLazyQueryHookResult = ReturnType<typeof useInvokableAISkillsLazyQuery>;
export type InvokableAISkillsSuspenseQueryHookResult = ReturnType<
  typeof useInvokableAISkillsSuspenseQuery
>;
export type InvokableAISkillsQueryResult = Apollo.QueryResult<
  InvokableAISkills,
  InvokableAISkillsVariables
>;
export function mockInvokableAISkills({
  data,
  variables,
  errors,
}: {
  data: InvokableAISkills;
  variables?: InvokableAISkillsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: InvokableAISkillsDocument, variables },
    result: { data, errors },
  };
}
